import { useEffect, useId, useState } from 'react';
import * as s from './CandidateCriteriaBar.css';

interface CandidateQueryProgressProps {
  state: 'queued' | 'running';
  requestedAt?: string | null;
}

export function CandidateQueryProgress({ state, requestedAt }: CandidateQueryProgressProps) {
  const [now, setNow] = useState(Date.now);
  const statusId = useId();
  const startedAt = requestedAt ? Date.parse(requestedAt) : NaN;
  const hasTime = Number.isFinite(startedAt);
  const seconds = hasTime ? Math.max(0, Math.floor((now - startedAt) / 1000)) : null;
  const status =
    state === 'queued' ? '후보 조회를 기다리고 있습니다.' : '후보를 조회하고 있습니다.';

  useEffect(() => {
    if (!hasTime) return;
    const timer = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(timer);
  }, [hasTime]);

  return (
    <div className={s.queryProgress}>
      <p id={statusId} className={s.progress} role="status" aria-atomic="true">
        {status} 걸리는 시간은 조건과 서버 상황에 따라 달라집니다.
      </p>
      <div
        className={s.progressTrack}
        role="progressbar"
        aria-label={status}
        aria-describedby={statusId}
      >
        <span className={s.progressSegment} />
      </div>
      <p className={s.elapsed} aria-live="off">
        {seconds === null
          ? '경과 시간을 확인할 수 없습니다.'
          : `요청 후 ${Math.floor(seconds / 60)}분 ${String(seconds % 60).padStart(2, '0')}초가 지났습니다.`}
      </p>
      <p className={s.progress}>기다리는 동안 조건을 고치거나 다른 나라로 옮겨도 됩니다.</p>
    </div>
  );
}
